import { useState } from "react";
import { useBetween } from "use-between";
import { BTGlobal } from "../../../utils/BTglobal/BTGlobal";
import { contStep4 } from "../form/StepContract4";
import { createContractSchemas } from "../ICreateContract";

const BTCreateContract4 = () => {
    const { btGridRef } = useBetween(BTGlobal)
    const [contractSchemas, setContractSchemas] = useState(createContractSchemas[0])
    const [dataRow4, setDataRow4] = useState<contStep4[]>([]);
    const [dataModelo4, setDataModelo4] = useState<any>();
    const addRowStructure4 = (props: any) => {
        let data = {
            fatherStructure3: props.dataRow.fatherStructure3,
            mainIngredients2: props.dataRow.mainIngredients2,
            frequency: props.dataRow.frequency,
            id: props.dataRow.id
        }

        setDataModelo4(data)
    }
    const updateRow4 = (items: any) => {
        let dRow = dataRow4.slice()
        setDataRow4([]);
        let newRow = dRow.filter((item) => {
            if (item.id === items.id) {
            }
            return item
        })
        setDataRow4(newRow);
        if (btGridRef !== undefined)
            btGridRef.current.api.refreshServerSideStore({ purge: true });
    }
    const deleteRow4 = (props: any) => {
        let rows = dataRow4.slice();
        let newRow = rows.filter((item) => {
            return item.idComodin !== props.dataRow.idComodin
                //|| item.data.id_estructura !== props.dataRow.data.id_estructura
                || item.fatherStructure3 !== props.dataRow.fatherStructure3
                || item.idMainIngredients2 !== props.dataRow.idMainIngredients2
        });
        setDataRow4(newRow)
    }
    return {
        contractSchemas, setContractSchemas,
        dataRow4, setDataRow4, updateRow4, deleteRow4,
        dataModelo4, setDataModelo4,
        addRowStructure4
    };
};
export { BTCreateContract4 }